import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { forkJoin, range } from 'rxjs';
import { bufferCount, concatMap, tap } from 'rxjs/operators';
import { ClientRecurrenceItem, ProductRecurrenceItem, RecurrenceRequest, RecurrenceResponse } from 'src/app/models/recurrence.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { AccountService } from 'src/app/services/account.service';
import { CashierService } from 'src/app/services/cashier.service';
import { ClientService } from 'src/app/services/client.service';
import { CountryService } from 'src/app/services/country.service';
import { ProductService } from 'src/app/services/product.service';
import { RecurrenceService } from 'src/app/services/recurrence.service';
import { WarehouseService } from 'src/app/services/warehouse.service';
declare let $: any;

@Component({
  selector: 'app-recurrence',
  templateUrl: './recurrence.component.html',
  styleUrls: ['./recurrence.component.scss']
})
export class RecurrenceComponent implements OnInit {
  products = [];
  loading = false;
  productsList = [];
  totalToPay = 0;
  warehouses = [];
  added: { [key: number]: boolean } = {};
  edited: { [key: number]: boolean } = {};
  departmentName: { [key: number]: string } = {};
  townName: { [key: string]: string } = {};
  clientCF = null;
  inputs = {
    warehouse: {
      value: null,
      required: true,
      verified: false,
      class: 'fa-asterisk',
      data: null,
      filterElements: []
    },
    product: {
      value: null,
      required: true,
      verified: false,
      class: 'fa-asterisk',
      data: null,
      filterElements: []
    },
    client: {
      value: null,
      required: false,
      verified: false,
      class: 'fa-list',
      data: null,
      filterElements: []
    },
    cashier: {
      value: null,
      required: false,
      verified: false,
      class: 'fa-list',
      data: null,
      filterElements: []
    }
  }
  tempProduct: ProductRecurrenceItem = null;
  recurrenceObject: RecurrenceRequest = new RecurrenceRequest();
  beginObject: RecurrenceResponse = null;
  clients = [];
  departments = [];
  listProducts = [];
  towns = [];
  tempLocation = {
    department: undefined,
    town: undefined
  }
  tempFact = {
    wantCF: false,
    percentage: undefined
  }
  locations = [];
  cashiers = [];
  banks = [];
  recurrenceTypeTemp = null;
  constructor(
    private toastService: ToastrService,
    private warehouseService: WarehouseService,
    private productService: ProductService,
    private clientService: ClientService,
    private recurrenceService: RecurrenceService,
    private countryService: CountryService,
    private vendorService: ClientService,
    private cashierService: CashierService,
    private accountService: AccountService
  ) {

  }

  clientList = [];
  tempUnifiedProducts = false;
  isLimitInvoicePrice = false;
  limitInvoicePrice = 0;

  ngOnInit(): void {
    this.getWarehouses();
    this.getClients();
    this.getProducts();
    this.getBegin();
    this.getDepartments();
    this.getCashiers();
    this.selectInitData();
    this.getBanks();
  }

  selectInitData(){
    this.recurrenceObject.typeClient = false;
    this.tempFact.wantCF = true;
    this.tempFact.percentage = 100;
    this.tempUnifiedProducts = true;
    this.clientService.getCF().subscribe({
      next: (response: ResponseObject) => {
        this.clientCF = response.data[0];
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    })
  }

  getCashiers() {
    this.cashierService.getCashiersByClue('').subscribe(
      {
        next: (response: ResponseObject) => {
          this.cashiers = response.data;
          this.inputs.cashier.filterElements = this.cashiers;
        },
        error: (error: HttpErrorResponse) => {
          this.toastService.error(error.error.message);
        }
      }
    );
  }

  getDepartments() {
    this.countryService.getDepartmentsByCountry(6).subscribe(
      {
        next: (response: ResponseObject) => {
          this.departments = response.data;
          this.departments.forEach((d) => {
            this.departmentName[d.id] = d.name;
          });
        },
        error: (error: HttpErrorResponse) => {
          this.toastService.error(error.error.message);
        }
      }
    );
  }

  setTowns() {
    if (this.tempLocation.department) {
      this.countryService.getTownsByDepartment(this.tempLocation.department, 6).subscribe(
        {
          next: (response: ResponseObject) => {
            this.towns = response.data;
            this.towns.forEach((d) => {
              this.townName[this.tempLocation.department + "#" + d.id] = d.name;
            });
            this.tempLocation.town = undefined;
          },
          error: (error: HttpErrorResponse) => {
            this.toastService.error(error.error.message);
          }
        }
      );
    } else {
      this.toastService.error("Ingresa un departamento primero");
    }
  }

  selectTown(value) {
    var townId = value.target.value;
    if (townId == 'undefined') {
      return;
    }
    var findOut = this.locations.find((l) => {
      return l.department == this.tempLocation.department && l.town == this.tempLocation.town
    })
    if (findOut) {
      this.toastService.info("Ya se encuentra añadida la localidad");
      return;
    }
    this.locations.push({ department: this.tempLocation.department, town: this.tempLocation.town });
  }

  activeCF() {
    this.tempFact.wantCF = !this.tempFact.wantCF;
    this.tempFact.percentage = (this.tempFact.wantCF) ? 100 : undefined;
    if (!this.clientCF) {
      this.clientService.getCF().subscribe({
        next: (response: ResponseObject) => {
          this.clientCF = response.data[0];
        },
        error: (error: HttpErrorResponse) => {
          this.toastService.error(error.error.message);
        }
      })
    }
  }

  getBegin() {
    this.recurrenceService.getBegin().subscribe(
      {
        next: (response: ResponseObject) => {
          this.beginObject = response.data;
        },
        error: (error: HttpErrorResponse) => {
          this.toastService.error(error.error.message);
        }
      }
    );
  }

  getWarehouses() {
    this.warehouseService.getWarehouseByClue('').subscribe({
      next: (response: ResponseObject) => {
        this.warehouses = response.data;
        this.inputs.warehouse.filterElements = this.warehouses;
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    })
  }

  getClients() {
    this.clientService.getClientsByClue('').subscribe({
      next: (response: ResponseObject) => {
        this.clients = response.data;
        this.inputs.client.filterElements = this.clients;

      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    })
  }

  getProducts() {
    if(this.recurrenceObject.recurrence == null || this.recurrenceObject.recurrence != '10'){
      this.productService.getProducts('').subscribe({
        next: (response: ResponseObject) => {
          this.products = response.data;
          this.inputs.product.filterElements = this.products;
        },
        error: (error: HttpErrorResponse) => {
          this.toastService.error(error.error.message);
        }
      })
    }else{
      if(this.recurrenceObject.wareHouse != null){
        this.productService.getProductsOrdered('',this.recurrenceObject.wareHouse).subscribe({
          next: (response: ResponseObject) => {
            this.products = response.data;
            this.inputs.product.filterElements = this.products;
          },
          error: (error: HttpErrorResponse) => {
            this.toastService.error(error.error.message);
          }
        })
      }else{
        this.toastService.error("Debe seleccionar una bodega antes de buscar los productos");
      }
      
    }
    
  }

  getBanks(){
    this.accountService.getAccounts().subscribe({
      next: (response: ResponseObject) => {

        this.banks = response.data;
      },
      error: (error: any) => {
        this.toastService.error("Error al obtener los bancos, por favor recarga la página");
      }
    });
  }

  resetTimes() {
    this.recurrenceObject.startTime = undefined;
    this.recurrenceObject.endTime = undefined;
    this.getProducts();
  }

  writeWarehouse(inputValue) {
    this.inputs.warehouse.filterElements = this.warehouses.filter((c) =>
      c.id == inputValue || c.name.toLowerCase().includes(inputValue.toLowerCase()) || c.nit == inputValue
    );
    this.recurrenceObject.wareHouse = null;
    switch (this.inputs.warehouse.filterElements.length) {
      case 0: {
        this.inputs.warehouse.class = "fa-xmark";
        this.inputs.warehouse.required = true;
        this.inputs.warehouse.verified = false;
        break;
      } default: {
        this.inputs.warehouse.class = "fa-list";
        this.inputs.warehouse.required = false;
        this.inputs.warehouse.verified = false;
      }
    }
  }

  selectWarehouse(warehouse) {
    this.inputs.warehouse.value = warehouse.title;
    this.inputs.warehouse.class = "fa-circle-check";
    this.inputs.warehouse.verified = true;
    this.inputs.warehouse.required = true;
    this.inputs.warehouse.data = warehouse;
    this.recurrenceObject.wareHouse = warehouse.id;
    if(this.recurrenceObject.recurrence != null && this.recurrenceObject.recurrence == '10'){
      this.getProducts();
    }
  }

  writeClient(inputValue) {
    this.inputs.client.filterElements = this.clients.filter((c) =>
      c.id == inputValue || c.name.toLowerCase().includes(inputValue.toLowerCase()) || c.nit == inputValue
    );
    switch (this.inputs.client.filterElements.length) {
      case 0: {
        this.inputs.client.class = "fa-xmark";
        this.inputs.client.required = true;
        this.inputs.client.verified = false;
        break;
      } default: {
        this.inputs.client.class = "fa-list";
        this.inputs.client.required = false;
        this.inputs.client.verified = false;
      }
    }
  }

  formatPercentage(){
    if (this.tempFact.percentage>100){
      this.tempFact.percentage = 100;
    } else if (this.tempFact.percentage < 0) {
      this.tempFact.percentage = 0;
    }
  }

  selectClient(client) {
    var tempClient = new ClientRecurrenceItem();
    tempClient['name'] = client.name;
    tempClient.id = client.id;
    tempClient.isNew = true;
    tempClient.numberInvoices = 1;
    this.recurrenceObject.clients.push(tempClient);
    this.inputs.client.value = "";
    this.inputs.client.class = "fa-list";
    this.inputs.client.verified = false;
    this.inputs.client.required = false;
    this.inputs.client.filterElements = this.clients;
    this.changeTotalFact("");
  }
  timeout = null;
  writeProduct(inputValue) {
    this.inputs.product.filterElements = this.products.filter((c) =>
      c.id == inputValue || c.name.toLowerCase().includes(inputValue.toLowerCase()) || c.code == inputValue
    );
    clearTimeout(this.timeout);
    switch (this.inputs.product.filterElements.length) {
      case 0: {
        this.inputs.product.class = "fa-xmark";
        this.inputs.product.required = true;
        this.inputs.product.verified = false;
        break;
      }
      case 1: {
        this.timeout = setTimeout(() => {
          this.selectProduct(this.inputs.product.filterElements[0]);
        }, 1000);
        break;
      }
      default: {
        this.inputs.product.class = "fa-list";
        this.inputs.product.required = false;
        this.inputs.product.verified = false;
      }
    }
  }

  writeCashier(inputValue) {
    this.inputs.cashier.filterElements = this.cashiers.filter((c) =>
      c.id == inputValue || c.name.toLowerCase().includes(inputValue.toLowerCase()) || c.nit == inputValue
    );
    this.recurrenceObject.cashierId = undefined;
    switch (this.inputs.product.filterElements.length) {
      case 0: {
        this.inputs.cashier.class = "fa-xmark";
        this.inputs.cashier.required = true;
        this.inputs.cashier.verified = false;
        break;
      }
      case 1: {
        this.timeout = setTimeout(() => {
          this.selectCashier(this.inputs.cashier.filterElements[0]);
        }, 1000);
        break;
      }
      default: {
        this.inputs.cashier.class = "fa-list";
        this.inputs.cashier.required = false;
        this.inputs.cashier.verified = false;
      }
    }
  }

  selectCashier(cashier) {
    clearTimeout(this.timeout);
    this.inputs.cashier.class = "fa-circle-check";
    this.inputs.cashier.value = cashier.name;
    this.inputs.cashier.required = true;
    this.inputs.cashier.data = cashier;
    this.inputs.cashier.verified = true;
  }

  selectProduct(product) {
    clearTimeout(this.timeout);
    this.inputs.product.class = "typing";
    this.inputs.product.value = product.name;
    this.inputs.product.required = false;
    if (product.type != 's') {
      forkJoin({
        cost: this.productService.getCostProduct(product.id),
        existence: this.productService.getExistence(this.inputs.warehouse.data.id, product.id)
      }).subscribe({
        next: (response) => {
          const costResponse = response.cost as ResponseObject;
          const existenceResponse = response.existence as ResponseObject;
          const cost = costResponse.data;
          const existence = existenceResponse.data;
          if (existence > 0 || cost > 0) {
            this.addToTemporalProduct(product);
            if (existence > 0) {
              this.tempProduct['existence'] = existence;
            }else{
              this.tempProduct['existence'] = 0;
            }
            if(cost != null && cost > 0){
              this.tempProduct['costProd'] = Math.round(cost * 100) / 100;
            }
            this.inputs.product.class = "";
              $('body').click();
              setTimeout(() => {
                $('#mount').focus();
              }, 100);
          }
        }
      });
    } else {
      this.addToTemporalProduct(product);
      this.inputs.product.class = "";
      $('body').click();
      setTimeout(() => {
        $('#mount').focus();
      }, 100);
    }
  }

  setProductTitle(product: any): void {
    if (this.recurrenceObject?.recurrence === '10') {
      product.title = `${product.code} - ${product.name} - ${product.existence ?? 0}`;
    } else {
      product.title = `${product.code} - ${product.name}`;
    }
  }

  addToTemporalProduct(product) {
    this.tempProduct = new ProductRecurrenceItem();
    this.tempProduct.exemptTextId = product.exemptTextId;
    this.tempProduct.id = product.id;
    this.tempProduct.name = product.name;
    this.tempProduct.price = 0;
    this.tempProduct.priceEdited = false;
    this.tempProduct.productDescription = product.name;
    this.tempProduct.quantity = 1;
    this.tempProduct.type = product.type;
  }

  deleteClient(index: number) {
    this.recurrenceObject.clients.splice(index, 1);
    this.changeTotalFact("");
  }

  deleteLocation(index: number) {
    this.locations.splice(index, 1);
  }

  addProduct() {
    const alreadyAdded = this.listProducts.some(p => p.id === this.tempProduct.id);
    if (alreadyAdded) {
      this.toastService.error("Este producto ya fue agregado a la factura");
      return;
    }

    if(this.tempProduct['existence'] != null){
      if(this.tempProduct.quantity > this.tempProduct['existence']){
        this.toastService.error("No hay suficientes existencias del producto para agregar a la factura");
        return;
      }
    }
    
    if (this.recurrenceObject.recurrence == '9') {
      this.tempProduct['units'] = 1;
    }
    this.listProducts.push(this.tempProduct);
    this.tempProduct = null;
    this.sumQuantities();
    this.inputs.product = {
      value: null,
      required: false,
      verified: false,
      class: '',
      data: null,
      filterElements: this.products
    }
    setTimeout(() => {
      this.scrollToEnd();
      if (this.recurrenceObject.recurrence == '9'){
        $('#units'+(this.listProducts.length-1)).focus();
      } else {
        $('#product-input').click();
        $('#product-input').focus();
      }
    }, 100);
  }

  sumQuantities() {
    this.totalToPay = 0;
    this.listProducts.forEach((p) => {
      this.totalToPay += p.quantity * p.price;
    })
  }

  scrollToEnd() {
    const miDiv = document.getElementById('miDiv') as HTMLDivElement;
    const con1 = document.getElementById('product-div') as HTMLDivElement;
    const con = document.getElementById('container-recurrence') as HTMLDivElement;
    miDiv.scrollTo(0, miDiv.scrollHeight);
    con1.scrollIntoView();
    //con.scrollTo(0, con.scrollHeight-20);
  }

  createRecurrence() {
    this.loading = true;
    if (this.recurrenceObject.recurrence == '9' || this.recurrenceObject.recurrence == '10') {
      for (let product of this.listProducts) {
        if (product['existence'] != null && product.quantity > product['existence']) {
          this.toastService.error(`La cantidad del producto "${product.name}" excede su existencia disponible (${product['existence']})`);
          this.loading = false;
          return;
        }
      }
      this.createRecurrenceSpecial();
    } else {
      this.recurrenceObject.products = this.listProducts;
      this.recurrenceService.saveRecurrence(this.recurrenceObject).subscribe({
        next: (response: ResponseObject) => {
          this.loading = false;
          this.reset();
          this.toastService.success("Configuración creada correctamente!");
        },
        error: (error: HttpErrorResponse) => {
          this.loading = false;
          this.toastService.error(error.error.message);
        }
      })
    }
  }

  createRecurrenceSpecial() {
    this.recurrenceObject.endDate = this.recurrenceObject.startDate;

    var tempProducts = this.listProducts;
    var tempEndTime = this.recurrenceObject.endTime;
    var tempStartTime = this.recurrenceObject.startTime;

    this.recurrenceObject.endTime = this.convertTimeToISOString(this.recurrenceObject.endTime);
    this.recurrenceObject.startTime = this.convertTimeToISOString(this.recurrenceObject.startTime);

    var orders = [];
    tempProducts.forEach((product) => {
        product['carry'] = 0;
    });

    // Agregar una condición de salida
    let allProductsProcessed = false;

    while (!allProductsProcessed) {
        allProductsProcessed = true; // Se asumirá que todos los productos están procesados a menos que se indique lo contrario

        if (this.tempUnifiedProducts) {
            var order = [];
            var orderTotal = 0;

            tempProducts.forEach((product) => {
                if (product.quantity > product.carry) {
                    allProductsProcessed = false; // Aún hay productos que necesitan ser procesados

                    let randomNum;
                    if (this.recurrenceObject.isPartial) {
                      let remainingQuantity = product.quantity - product.carry;
                      let maxByLimit = remainingQuantity;
                      
                      if (this.isLimitInvoicePrice) {
                          const remainingLimit = this.limitInvoicePrice - orderTotal;
                          const maxByPrice = parseFloat((remainingLimit / product.price).toFixed(2));
                          maxByLimit = Math.min(maxByLimit, maxByPrice);
                      }
                      
                      if (product.units && product.units > 0) {
                          maxByLimit = Math.min(maxByLimit, product.units);
                      }
                      
                      if (maxByLimit <= 0) {
                          return;
                      }
                      
                      randomNum = parseFloat((Math.random() * maxByLimit).toFixed(2));
                      
                      if (randomNum < 0.1) randomNum = Math.min(0.1, maxByLimit);
                      
                    } else {
                        randomNum = Math.floor(Math.random() * product.units) + 1;
                    }

                    // Evitar que randomNum sea 0
                    if (randomNum <= 0) randomNum = 0.1;

                    if (randomNum + product.carry > product.quantity) {
                        randomNum = product.quantity - product.carry;
                    }

                    let productTotal = randomNum * product.price;

                    if (this.isLimitInvoicePrice && (orderTotal + productTotal) > this.limitInvoicePrice) {
                        if (order.length > 0) {
                            orders.push({ order: order });
                            order = [];
                            orderTotal = 0;
                        }
                    }

                    product.carry += randomNum;
                    let { carry, units, existence, ...clone } = product;
                    clone.quantity = randomNum;
                    clone.limitProduct = product.units;
                    order.push(clone);
                    orderTotal += productTotal;
                }
            });

            if (order.length > 0) orders.push({ order: order });

        } else {
            var singleOrders = [];

            tempProducts.forEach((product) => {
                if (product.quantity > product.carry) {
                    allProductsProcessed = false; // Todavía hay productos por procesar

                    let randomNum;
                    if (this.recurrenceObject.isPartial) {
                      let remainingQuantity = product.quantity - product.carry;
                      let maxByLimit = remainingQuantity;
                      
                      if (this.isLimitInvoicePrice) {
                          const remainingLimit = this.limitInvoicePrice - orderTotal;
                          const maxByPrice = parseFloat((remainingLimit / product.price).toFixed(2));
                          maxByLimit = Math.min(maxByLimit, maxByPrice);
                      }
                      
                      if (product.units && product.units > 0) {
                          maxByLimit = Math.min(maxByLimit, product.units);
                      }
                      
                      if (maxByLimit <= 0) {
                          return;
                      }
                      
                      randomNum = parseFloat((Math.random() * maxByLimit).toFixed(2));
                      
                      if (randomNum < 0.1) randomNum = Math.min(0.1, maxByLimit);
                    } else {
                        randomNum = Math.floor(Math.random() * product.units) + 1;
                    }

                    // Evitar que randomNum sea 0
                    if (randomNum <= 0) randomNum = 0.1;

                    if (randomNum + product.carry > product.quantity) {
                        randomNum = product.quantity - product.carry;
                    }

                    let productTotal = randomNum * product.price;
                    let parts = 1;

                    if (this.isLimitInvoicePrice && productTotal > this.limitInvoicePrice) {
                        parts = Math.ceil(productTotal / this.limitInvoicePrice);
                        randomNum = parseFloat((randomNum / parts).toFixed(2));
                    }

                    product.carry += randomNum * parts;

                    for (let i = 0; i < parts; i++) {
                        let { carry, units, existence, ...clone } = product;
                        clone.quantity = randomNum;
                        clone.limitProduct = product.units;
                        singleOrders.push({ order: [clone] });
                    }
                }
            });

            if (singleOrders.length > 0) orders.push(...singleOrders);
        }
    }

    this.recurrenceObject.products = orders;
    this.recurrenceObject.typeClient = !!this.recurrenceObject.typeClient;
    this.recurrenceObject.clients = [];

    var minus = (this.tempFact.wantCF) ? Math.floor(this.recurrenceObject.products.length * (this.tempFact.percentage) / 100) : 0;
    var maxClients = (this.tempFact.wantCF) ? this.recurrenceObject.products.length - minus : this.recurrenceObject.products.length;

    var newClients = [];

    for (let i = 0; i < maxClients; i++) {
        var tempClient = new ClientRecurrenceItem();
        tempClient.id = this.clientCF.id;
        tempClient.isNew = true;
        tempClient.numberInvoices = 1;
        tempClient['nit'] = this.clientCF.nit;
        tempClient['name'] = this.clientCF.name;
        newClients.push(tempClient);
    }


    if (this.tempFact.wantCF) {
        for (let i = 0; i < minus; i++) {
            var tempClient = new ClientRecurrenceItem();
            tempClient.id = this.clientCF.id;
            tempClient.isNew = true;
            tempClient.numberInvoices = 1;
            tempClient['nit'] = this.clientCF.nit;
            tempClient['name'] = this.clientCF.name;
            newClients.push(tempClient);
        }
    }

    this.recurrenceObject.clients = this.shuffleArray([...newClients]);

    if(this.recurrenceObject.idBank === undefined){
      this.recurrenceObject.idBank = 0;
    }

    if(this.recurrenceObject.isCashier === true){
      this.recurrenceObject.cashierId = this.inputs.cashier.data.id;
    }

    if(this.isLimitInvoicePrice === true){
      this.recurrenceObject.limitPrice = this.limitInvoicePrice;
    }

    this.recurrenceTypeTemp = this.recurrenceObject.recurrence;
    this.recurrenceObject.recurrence = '9';

    // console.log(this.recurrenceObject);

    this.recurrenceService.saveRecurrence(this.recurrenceObject).subscribe({
      next: (response: ResponseObject) => {
          this.loading = false;
          if (response.data.isOk) {
              this.toastService.success("Configuración especial creada correctamente, se crearán " + this.recurrenceObject.products.length + " facturas");
              this.recurrenceObject.recurrence = this.recurrenceTypeTemp;
              this.recurrenceTypeTemp = null;
              this.reset();
          } else {
              this.recurrenceObject.startTime = tempStartTime;
              this.recurrenceObject.endTime = tempEndTime;
              this.toastService.error("Problemas al generar la configuración");
              this.recurrenceObject.recurrence = this.recurrenceTypeTemp;
              this.recurrenceTypeTemp = null;
          }
      },
      error: (error: HttpErrorResponse) => {
          this.loading = false;
          this.toastService.error(error.error.message);
          this.recurrenceObject.recurrence = this.recurrenceTypeTemp;
          this.recurrenceTypeTemp = null;
      }
    });
    

    this.loading = false;

  }

  onBankChange(event: any): void {
    const selectedBankId = this.recurrenceObject.idBank;
    const selectedBank = this.banks.find(bank => bank.id === selectedBankId);
  
    if (selectedBank) {
      this.recurrenceObject.bankDescription = `${selectedBank.accountNumber} - ${selectedBank.alias}`;
    } else {
      this.recurrenceObject.bankDescription = '';
    }
  }
  


  shuffleArray(array: any[]): any[] {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
  }

  convertTimeToISOString(timeString: string): string {
    const today = new Date();
    const [hours, minutes] = timeString.split(':').map(Number);
    today.setHours(hours);
    today.setMinutes(minutes);
    today.setSeconds(0);
    today.setMilliseconds(0);
    return today.toISOString();
  }

  changeTotalFact(inputValue) {
    this.recurrenceObject.totalFacts = 0;
    this.recurrenceObject.clients.forEach((c) => {
      this.recurrenceObject.totalFacts += c.numberInvoices;
    })
  }

  reset() {
    this.recurrenceObject = new RecurrenceRequest();
    this.listProducts = [];
    this.totalToPay = 0;
    this.inputs = {
      warehouse: {
        value: null,
        required: true,
        verified: false,
        class: 'fa-asterisk',
        data: null,
        filterElements: this.warehouses
      },
      product: {
        value: null,
        required: true,
        verified: false,
        class: 'fa-asterisk',
        data: null,
        filterElements: this.products
      },
      client: {
        value: null,
        required: false,
        verified: false,
        class: 'fa-list',
        data: null,
        filterElements: this.clients
      },
      cashier: {
        value: null,
        required: false,
        verified: false,
        class: 'fa-list',
        data: null,
        filterElements: this.cashiers
      }
    }
  }

  deleteProduct(index) {
    this.listProducts.splice(index, 1);
    this.sumQuantities();
  }

  validatePositiveNumber(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.value && Number(input.value) < 0) {
      input.value = '0'; // Resetea el valor si es negativo
    }
  }
  
  onNumberChange(value: string): void {
    const numericValue = Number(value);
    if (!isNaN(numericValue) && numericValue >= 0) {
      // Aquí puedes hacer lo que necesites con el valor positivo
    }
  }
}
